import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBonus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 17 17",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M3.7,9.2L1,12.5L3.5,13l1,3l2.6-4.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M13.3,9.2l2.7,3.3L13.5,13l-1,3l-2.6-4.2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			cx: 8.5,
			cy: 6.5,
			r: 5.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M8.9,3.4L9.7,5h1.4c0.2,0,0.4,0.2,0.4,0.4c0,0.1,0,0.2-0.1,0.3l-1.3,1.3l0.7,1.7 c0.1,0.2,0,0.4-0.2,0.5c-0.1,0-0.2,0-0.3,0l-1.7-1l-1.7,1c-0.2,0.1-0.4,0-0.5-0.1c-0.1-0.1-0.1-0.2,0-0.3l0.7-1.7L5.6,5.7 c-0.2-0.2-0.2-0.4,0-0.5C5.7,5,5.8,5,5.9,5h1.4l0.8-1.6c0.1-0.2,0.3-0.3,0.5-0.2C8.8,3.2,8.8,3.3,8.9,3.4z"
		})
	] })
});
export { SvgIconBonus as ReactComponent };
